var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVis = function SvgVis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283.5,
    height: 283.5,
    xmlSpace: "preserve",
    viewBox: "0 0 283.5 283.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_13"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    fill: "#1A1D56",
    d: "m80.79771,189.07378c0,-7.70668 6.28109,-14.27163 14.27521,-14.27163l0,-175.82645l-95.07292,0l0,284.86169l95.07292,0l0,-80.77741c-7.99412,0 -14.27521,-6.27952 -14.27521,-13.9862z",
    className: "stc56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    fill: "#9199B3",
    d: "m173.01559,209.91036c-11.99118,0 -21.69832,-9.70471 -21.69832,-21.69287s9.70715,-21.69287 21.69832,-21.69287c11.99118,0 21.69832,9.70471 21.69832,21.69287s-9.70715,21.69287 -21.69832,21.69287zm0,-37.39166c-8.56513,0 -15.70273,7.13581 -15.70273,15.69879s7.13761,15.69879 15.70273,15.69879s15.70273,-7.13581 15.70273,-15.69879s-7.13761,-15.69879 -15.70273,-15.69879z",
    className: "stc57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    fill: "#1A1D56",
    d: "m182.43723,200.49108c-6.8521,0 -12.27668,-5.42322 -12.27668,-12.2736c0,-6.85038 5.42458,-12.2736 12.27668,-12.2736c6.8521,0 12.27668,5.42322 12.27668,12.2736c0,6.56495 -5.42458,12.2736 -12.27668,12.2736zm0,-18.83855c-3.42605,0 -6.28109,2.85433 -6.28109,6.27952c0,3.42519 2.85504,6.27952 6.28109,6.27952c3.42605,0 6.28109,-2.85433 6.28109,-6.27952c0,-3.42519 -2.85504,-6.27952 -6.28109,-6.27952z",
    className: "stc56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    fill: "#9199B3",
    d: "m146.7492,235.59929c-11.99118,0 -23.98236,-1.7126 -35.40253,-5.13779c-1.71303,-0.57087 -2.56954,-2.28346 -1.99853,-3.71062c0.57101,-1.7126 2.28403,-2.56889 3.71156,-1.99803c10.84916,3.42519 22.26933,5.13779 33.6895,5.13779c42.54014,0 81.36872,-23.12004 101.92503,-60.5117c-20.2708,-37.39166 -59.09938,-60.5117 -101.92503,-60.5117c-11.42017,0 -22.84034,1.7126 -33.6895,5.13779c-1.71303,0.57087 -3.14055,-0.28543 -3.71156,-1.99803c-0.57101,-1.7126 0.2855,-3.13976 1.99853,-3.71062c11.42017,-3.42519 23.41135,-5.13779 35.40253,-5.13779c45.39518,0 86.7933,25.11806 107.92061,65.07862c0.57101,0.8563 0.57101,1.99803 0,2.85433c-21.41282,39.38969 -62.52544,64.50776 -107.92061,64.50776z",
    className: "stc57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_5",
    fill: "#1A1D56",
    d: "m146.7492,120.56997c-1.71303,0 -3.14055,-1.42716 -3.14055,-3.13976l0,-49.0944c0,-1.7126 1.42752,-3.13976 3.14055,-3.13976s3.14055,1.42716 3.14055,3.13976l0,49.0944c-0.2855,1.7126 -1.42752,3.13976 -3.14055,3.13976z",
    className: "stc56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_6",
    fill: "#1A1D56",
    d: "m183.29374,126.84948c-0.2855,0 -0.57101,0 -1.14202,-0.28543c-1.42752,-0.57087 -2.28403,-2.28346 -1.71303,-3.99606l16.84475,-45.95464c0.57101,-1.42716 2.28403,-2.28346 3.99706,-1.7126c1.42752,0.57087 2.28403,2.28346 1.71303,3.99606l-16.84475,45.95464c-0.57101,1.14173 -1.71303,1.99803 -2.85504,1.99803z",
    className: "stc56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_7",
    fill: "#1A1D56",
    d: "m215.27022,145.4026c-0.57101,0 -1.42752,-0.28543 -1.99853,-0.57087c-1.14202,-1.14173 -1.42752,-2.85433 -0.2855,-4.28149l31.40547,-37.6771c1.14202,-1.14173 2.85504,-1.42716 4.28256,-0.28543c1.14202,1.14173 1.42752,2.85433 0.2855,4.28149l-31.40547,37.6771c-0.57101,0.57087 -1.42752,0.8563 -2.28403,0.8563z",
    className: "stc56"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "Fond"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    id: "svg_8",
    fill: "#1A1D56",
    r: 7.1284,
    cy: 189.07378,
    cx: 94.78742,
    className: "stc56"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "Texte"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_9"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_10",
    fill: "#FFFFFF",
    d: "m43.96766,66.33778l-7.42311,0l-16.84475,-50.80699l10.27815,0l10.27815,33.11018l10.27815,-33.11018l10.27815,0l-16.84475,50.80699z",
    className: "stc58"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_11",
    fill: "#FFFFFF",
    d: "m35.40253,137.69592l0,-50.80699l9.99265,0l0,50.80699l-9.99265,0z",
    className: "stc58"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_12",
    fill: "#FFFFFF",
    d: "m39.11409,209.62492c-7.70862,0 -13.70421,-1.7126 -18.55778,-6.56495l6.28109,-6.27952c3.14055,3.13976 7.70862,4.28149 12.27668,4.28149c5.99559,0 9.13614,-2.28346 9.13614,-6.27952c0,-1.7126 -0.57101,-3.13976 -1.71303,-4.28149c-0.85651,-0.8563 -1.99853,-1.42716 -4.56807,-1.7126l-5.99559,-0.8563c-4.56807,-0.57087 -7.42311,-1.99803 -9.70715,-4.28149c-2.28403,-2.28346 -3.71156,-5.70865 -3.71156,-9.99014c0,-9.13384 6.5666,-15.41336 17.70126,-15.41336c6.8521,0 11.99118,1.7126 16.55925,5.99408l-6.28109,6.27952c-3.14055,-3.13976 -7.13761,-3.42519 -10.27815,-3.42519c-5.13908,0 -7.70862,2.85433 -7.70862,6.27952c0,1.42716 0.2855,2.56889 1.42752,3.71062c0.85651,0.8563 2.56954,1.7126 4.56807,1.99803l5.99559,0.8563c4.56807,0.57087 7.42311,1.7126 9.70715,3.99606c2.56954,2.56889 3.99706,5.99408 3.99706,10.561c-0.2855,9.41927 -8.27962,15.12793 -19.12879,15.12793z",
    className: "stc58"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vis.35599a28.svg";
export { ForwardRef as ReactComponent };